export const toBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const capitalizeFirstLetter = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

export const maskMoney = (campo: string) => {
  if (campo) {
    campo = campo.toString();
    if (campo.indexOf('R$') === -1) {
      // caso não exista 'R$' na string, significa que é o primeiro valor, que vem do banco cru
      campo = `R$ ${parseFloat(campo)
        .toFixed(2)
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+,)/g, '$1.')}`;
    } else {
      const temp = parseInt(campo.replace(/[\D]+/g, ''), 10); // converte para inteiro e retira todos os caracteres nao numéricos
      let tmp: any = `${temp}`;
      if (tmp.length <= 2) {
        if (tmp.length === 1) {
          campo = `R$ 0,0${tmp}`;
        } else {
          campo = `R$ 0,${tmp}`;
        }
      } else {
        tmp = tmp.replace(/([0-9]{2})$/g, ',$1'); // coloca os digitos de centavos
        tmp = tmp.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'); // separa os milhares colocando ponto

        if (tmp === 'NaN' || temp === undefined) {
          tmp = 0;
        }

        if (tmp === 0) {
          campo = 'R$ 0,00';
        } else {
          campo = `R$ ${tmp}`;
        }
      }
    }
  } else {
    campo = 'R$ 0,00';
  }

  return campo;
};

export const desMoney = (valor: any) => {
  // recebe um valor (string) no formato 'R$ 00,00' e converte para o formato 0.0 como float, para fazer calculos, cadastrar no banco, etc
  const valor_formatado = parseFloat(valor.replace(/[\D]+/g, '')) / 100;
  return valor_formatado;
};

export const money = (valor: any) => {
  // formata o valor para o formato 'R$ 00,00' para exibição
  const valor_formatado = `R$ ${parseFloat(valor)
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+,)/g, '$1.')}`;
  return valor_formatado;
};
